import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { HandCoins } from '@phosphor-icons/react';
import { offersAPI, formatApiError } from '../../services/api';
import { toast } from 'sonner';

export function OfferSection({ productId, isAuthenticated, formatCurrency, navigate }) {
  const [offerAmount, setOfferAmount] = useState('');
  const [offerMessage, setOfferMessage] = useState('');
  const [sendingOffer, setSendingOffer] = useState(false);

  const handleMakeOffer = async () => {
    if (!isAuthenticated) { toast.error('Please login to make an offer'); navigate('/login'); return; }
    const amount = parseFloat(offerAmount);
    if (isNaN(amount) || amount <= 0) { toast.error('Enter a valid offer amount'); return; }
    setSendingOffer(true);
    try {
      await offersAPI.makeOffer(productId, amount, offerMessage);
      toast.success(`Offer of ${formatCurrency(amount)} submitted!`);
      setOfferAmount('');
      setOfferMessage('');
    } catch (error) { toast.error(formatApiError(error)); }
    finally { setSendingOffer(false); }
  };

  return (
    <Card className="mt-4 bg-[#0D1F17] border border-[#22C55E]/20 rounded-sm shadow-none" data-testid="offer-section">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <HandCoins className="w-5 h-5 text-[#22C55E]" />
          <span className="text-sm font-bold text-white">Make Your Offer</span>
        </div>
        <div className="space-y-3">
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[#999999]">$</span>
            <Input type="number" step="1" min="1" placeholder="Enter your offer" value={offerAmount} onChange={(e) => setOfferAmount(e.target.value)} className="rounded-sm bg-[#111111] border-[#333333] text-white pl-8 h-12" data-testid="offer-amount-input" />
          </div>
          <Textarea placeholder="Add a message (optional)" value={offerMessage} onChange={(e) => setOfferMessage(e.target.value)} className="rounded-sm bg-[#111111] border-[#333333] text-white text-sm resize-none" rows={2} data-testid="offer-message-input" />
          <Button onClick={handleMakeOffer} disabled={sendingOffer} className="w-full bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-sm h-11 font-semibold" data-testid="submit-offer-button">
            <HandCoins className="w-4 h-4 mr-2" />
            {sendingOffer ? 'Submitting...' : 'Submit Offer'}
          </Button>
        </div>
        <p className="text-[10px] text-[#666666] mt-3 text-center">The seller will review your offer and accept or decline it. Payment is from your wallet balance.</p>
      </CardContent>
    </Card>
  );
}
